import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["participant"]

  connect() {
    // Listen to toggle changes
    this.boundChange = event => { if (event.target.name === "show_names") this.toggleNames() }
    this.element.addEventListener("change", this.boundChange)

    // Set initial state
    this.updateParticipantDisplay()
  }

  disconnect() {
    this.element.removeEventListener("change", this.boundChange)
  }

  toggleNames() {
    this.updateParticipantDisplay()
  }

  updateParticipantDisplay() {
    const checkbox = this.element.querySelector('input[name="show_names"]')
    const showNames = checkbox ? checkbox.checked : true

    this.participantTargets.forEach((participant) => {
      const name = participant.dataset.name
      const number = participant.dataset.number

      participant.textContent = showNames ? name : `${participant.dataset.subjectLabel || "Participant"} ${number}`
    })
  }
}
